import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import HideButton from 'Components/UI/HideButton';

const toggleHideAction = {
  columnName: 'Hide',
  component: HideButton,
  onSubmit: async (resource, onSuccess, onFailure) => {
    try {
      if (resource.attr('ignored') === 'true') {
        resource.attr('ignored', 'false');
      } else {
        resource.attr('ignored', 'true');
      }
      await resource.submit();
      if (resource.attr('ignored') === 'true') {
        displaySuccess('Transaction hidden');
      } else {
        displaySuccess('Transaction unhidden');
      }
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      displayErrorMessage(err, err.errors);
      if (onFailure) {
        onFailure();
      }
    }
  },
};

export default toggleHideAction;
